import {createSlice} from '@reduxjs/toolkit'

interface anavezneModel {
  allCustomers: any[]
  filteredCustomers: any[]
  searchedCustomers: any[]
}

const initialState: anavezneModel = {
  allCustomers: [],
  filteredCustomers: [],
  searchedCustomers: [],
}

const customersSlice = createSlice({
  name: 'customers',
  initialState,
  reducers: {
    setAllCustomers(state, action) {
      state.allCustomers = action.payload.Detail
    },
    setFilteredCustomers(state, action) {
      state.filteredCustomers = action.payload
    },
    setSearchedCustomers(state, action) {
      state.searchedCustomers = action.payload
    },
    sortSearchedCustomers(state, action) {
      const {column, sortOrder} = action.payload

      const sortedCustomers = [...state.searchedCustomers] // Yeni bir kopya dizi oluşturun

      sortedCustomers.sort((a: any, b: any) => {
        const valueA = a[column]
        const valueB = b[column]

        if (valueA === null && valueB === null) {
          return 0
        }
        if (valueA === null) {
          return sortOrder === 'asc' ? 1 : -1 // Büyükten küçüğe sıralama
        }
        if (valueB === null) {
          return sortOrder === 'asc' ? -1 : 1 // Büyükten küçüğe sıralama
        }

        if (typeof valueA === 'number' && typeof valueB === 'number') {
          return sortOrder === 'asc' ? valueA - valueB : valueB - valueA
        } else if (typeof valueA === 'string' && typeof valueB === 'string') {
          return sortOrder === 'asc' ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA)
        } else {
          return 0
        }
      })

      state.searchedCustomers = sortedCustomers // Sıralanmış diziyi state'e atayın
    },
  },
})

export const {setAllCustomers, setFilteredCustomers, setSearchedCustomers, sortSearchedCustomers} =
  customersSlice.actions

export default customersSlice.reducer
